const API_URL = process.env.CATALOGS_API_URL || process.env.VUE_APP_CATALOGS_API_URL;

const fetchRequest = (typeof fetch === 'function') ? fetch : require('node-fetch');

const catalogAvailables = {
  bank: 'banks',
  country: 'countries',
  contractType: 'contractTypes',
  currency: 'currencies',
  customs: 'customs',
  customsPatent: 'customsPatents',
  customsShipperNumber: 'customsShipperNumbers',
  deductionType: 'deductionTypes',
  hourType: 'hourTypes',
  jobRisk: 'jobRisks',
  laborType: 'laborTypes',
  otherPaymentType: 'otherPaymentTypes',
  payLeaveType: 'payLeaveTypes',
  paymentForm: 'paymentForms',
  paymentMethod: 'paymentMethods',
  paymentPeriodicity: 'paymentsPeriodicity',
  payrollType: 'payrollTypes',
  perceptionType: 'perceptionTypes',
  productServiceKey: 'productServiceKeys',
  regimeType: 'regimeTypes',
  relationType: 'relationTypes',
  resourceOrigin: 'resourceOrigins',
  state: 'states',
  tax: 'taxes',
  taxRateOrFee: 'taxRateOrFees',
  taxRegime: 'taxRegimes',
  cfdiUse: 'cfdiUses',
  unitKey: 'unitKeys',
  voucherType: 'voucherTypes',
  zipCode: 'zipCodes',
};

/**
 * @param {string} catalogName
 * @param {object} params data in a query string.
 * @return {array} elements consumed
 */
const getCatalogSatAll = async (catalogName, params = {}) => {
  const queryString = {
    Active: true,
    ...params,
  };

  const qs = new URLSearchParams(queryString);
  const headers = {
    method: 'GET',
    'Content-Type': 'application/json',
  };

  if (!API_URL) {
    const error = new Error('apiCatalogSat - CATALOGS_API_URL not exists');
    error.status = 409;

    throw error;
  }

  const objectReturn = catalogAvailables[catalogName];

  if (!objectReturn) {
    return null;
  }

  const response = await fetchRequest(`${API_URL}/api/${catalogName}/all?${qs}`, headers);

  if (!response.ok) {
    return [];
  }

  try {
    const responseData = await response.json();

    return responseData[objectReturn] || null;
  } catch (e) {
    const error = new Error(`apiCatalogSat - ${e.message}`);
    error.status = 409;

    throw error;
  }
};

/**
 * @param {string} catalogName
 * @param {string} key Value to compare
 * @return {object} First item found
 */
const getCatalogSatByKey = async (catalogName, key) => {
  const [catalog] = await Promise.all([
    getCatalogSatAll(catalogName, { key, Active: '' }),
  ]);

  if (catalog && catalog.length > 0) {
    return catalog[0];
  }

  return null;
};

module.exports = {
  getCatalogSatByKey,
  getCatalogSatAll,
};
